/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { DocRejectedForm, Header, TerminateFormModal } from '../components';
import {
  useSMGetApplications,
  useSMGetWPApplications,
  useSMRenewWorkPermitPage,
  useSMTerminateWPPage,
  useSMAppealApplication,
  useSMRenewCSMECertPage,
  useSMGetCertificate,
  useSMRejectedDocumentsApplication,
  useSMStatusTimeLinePage,
  useSMRenewMarriageExemptionPage,
  useSMRejectedDocsApplicant,
} from '../machines';
import { toCamelCase, toUpperCase } from 'js-convert-case';
import humanizeString from 'humanize-string';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { vappContainer, VApplication } from '../../../application';
import { ApplicationDetailPageService } from '../services';
import { ApplicationFormPageService } from '@/pages/ApplicationForm';
import { ItemSpecVenusWidget } from '../../../widgets/item-spec-venus-widget-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { useApplication } from '../services/provider';
import { TimelineMercury } from '@vlinder-web/timeline-mercury-widget-react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { logger as log, logger } from '@common/logger';
import { Button } from 'react-bootstrap';
import { AppealForm } from '../components/AppealForm';
import { MissingInfoForm } from '../components/MissingInfoForm';
import { toast } from 'react-hot-toast';
import moment from 'moment';
import { USER_LEVEL } from '@/config/userManagement.config';
import { AppNavigatorService } from '@/AppNavigator';
import { APPLICATION_STATUS } from '@/config/applicationStatus.config';
import { Comments } from '@/pages/ApplicationDetail/components/comments';
import { getWidgetData, getMarriageWidgetData } from '../components';
import { Loader } from '@/components';
import { useSMresubmitApplicationByApplicantPage } from '@/pages/ApplicationForm/machines/resubmitapplicant';
import { useSMGetPdf } from '../machines/getPdf';

const getSrv = () => {
  return vappContainer.get<ApplicationDetailPageService>(
    ApplicationDetailPageService.displayName
  );
};

const getApplicationSrv = () => {
  return vappContainer.get<ApplicationFormPageService>(
    ApplicationFormPageService.displayName
  );
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});
  const [showModal, setShowModal] = useState({
    type: '',
    show: false,
  });
  const [showcomment, setShowComment] = useState(false);
  const [whoAmI, setWhoAmI] = useState('');
  const history = useNavigate();
  const location = useLocation();
  let appealSuccess = false;
  const [initialData, setinitialData] = useState({});
  const { isRenew } = useApplication();
  const { applicationNo, credentialNo } = useApplication();
  const [isAppealed, setAppeal] = useState(false);
  const [timelinedata, setTimelineData] = useState([]);
  // const [appli]
  const [isComment, setIsComment] = useState(false);
  const { renewWorkPermitPageSend, renewWorkPermitPageState } =
    useSMRenewWorkPermitPage({});
  const {
    renewMarriageExemptionPageMachine,
    renewMarriageExemptionPageSend,
    renewMarriageExemptionPageState,
  } = useSMRenewMarriageExemptionPage({});
  const {
    appealApplicationMachine,
    appealApplicationSend,
    appealApplicationState,
  } = useSMAppealApplication({});
  const {
    rejectedDocumentsApplicationMachine,
    rejectedDocumentsApplicationSend,
    rejectedDocumentsApplicationState,
  } = useSMRejectedDocumentsApplication({});
  const {
    RejectedDocsApplicantMachine,
    RejectedDocsApplicantSend,
    RejectedDocsApplicantState,
  } = useSMRejectedDocsApplicant({});
  const appSrv = getAppSrv();
  const staticApplicationContentConfig =
    getApplicationSrv().agent.getStaticPageContentSync({});
  const {
    workPermitFormData,
    csmeFormData,
    renewCsmeFormData,
    renewWorkPermitFormData,
    csmeVerificationFormData,
    marriageExemptionFormData,
    roeworkPermitFormData,
  } = staticApplicationContentConfig;
  console.log('staticApplicationContentConfig::->', staticPageContentConfig);
  const { getApplicationPageSend, getApplicationPageState } =
    useSMGetApplications({});
  const { getWPApplicationPageSend, getWPApplicationPageState } =
    useSMGetWPApplications({});
  const { getCertificatePageSend, getCertificatePageState } =
    useSMGetCertificate({});
  const { getPdfPageMachine, getPdfPageSend, getPdfPageState } = useSMGetPdf(
    {}
  );
  const { terminateWPPageSend, terminateWPPageState } = useSMTerminateWPPage(
    {}
  );

  const {
    statusTimeLinePageMachine,
    statusTimeLinePageSend,
    statusTimeLinePageState,
  } = useSMStatusTimeLinePage({});
  const { renewCSMECertPageSend, renewCSMECertPageState } =
    useSMRenewCSMECertPage({});
  const storageService = StorageModule.getInstance();
  const [data, setData] = useState();
  const userProfile = storageService.get('userProfile', 'session');
  const oragrole = userProfile?.orgRole;
  console.log('orgRole-->appdetailpage', oragrole);
  // console.log(
  //   'master-> #1',
  //   initialData,
  //   getCertificatePageState?.event?.data?.value,
  //   getWPApplicationPageState?.event?.data?.value
  // );
  console.log('data?.status', data);
  useEffect(() => {
    if (statusTimeLinePageState?.matches('RENDER_PAGE')) {
      setTimelineData(statusTimeLinePageState?.event?.data?.value?.data);
    }
  }, [statusTimeLinePageState]);

  console.log('cred->', credentialNo, typeof credentialNo);

  useEffect(() => {
    if (typeof credentialNo === 'string' && location?.state?.type === 'WP') {
      console.log('jramdata->', getWPApplicationPageState?.event?.data?.value);
      setinitialData(getWPApplicationPageState?.event?.data?.value ?? {});
      setData(getWPApplicationPageState?.event?.data?.value ?? {});
    } else if (
      credentialNo &&
      typeof credentialNo === 'string' &&
      location?.state?.type !== 'WP'
    ) {
      setinitialData(getCertificatePageState?.event?.data?.value ?? {});
      setData(getCertificatePageState?.event?.data?.value ?? {});
      //
    } else {
      console.log('jramdata->', getApplicationPageState?.event?.data?.value);
      setinitialData(getApplicationPageState?.event?.data?.value ?? {});
      setData(getApplicationPageState?.event?.data?.value ?? {});
    }
  }, [
    getApplicationPageState?.event?.data?.value,
    getWPApplicationPageState?.event?.data?.value,
    getCertificatePageState?.event?.data?.value,
  ]);

  useEffect(() => {
    if (getPdfPageState?.event?.data?.value?.pdf) {
      // logger.log("file->jram-->cameinside",getPdfPageState?.event?.data?.value?.pdf)
      setinitialData({
        ...initialData,
        pdf: getPdfPageState?.event?.data?.value?.pdf,
      });

      try {
        // const _pdfFile = await getSrv()?.agent?.getPdfDetail(credentialNo || credentialNo || applicationNo)
        if (getPdfPageState?.event?.data?.value?.pdf) {
          console.log('nate2', credentialNo ?? applicationNo);
          let byteCharacters = atob(getPdfPageState?.event?.data?.value?.pdf);
          let byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let _fileName = credentialNo ?? applicationNo;
          console.log('nate223', credentialNo ?? applicationNo);
          let byteArray = new Uint8Array(byteNumbers);
          let file = new Blob([byteArray], { type: 'application/pdf' });
          let fileName = `${_fileName}.pdf`;
          let link = document.createElement('a');
          link.href = URL.createObjectURL(file);
          link.download = fileName;
          link.click();
          // let fileURL = URL.createObjectURL(file);

          // console.log('file->jram', fileURL);
          // window.open(fileURL, '_blank');
        }
      } catch (err: any) {
        console.log('Pdf Not Available', err);
        toast.error(err || 'Failed to download Application, Please try again.');
      }
    }
  }, [getPdfPageState?.event?.data?.value]);
  useEffect(() => {
    if (
      appealApplicationState?.value === 'APPEAL_APPLICATION_SUCCESS' ||
      appealApplicationState?.value === 'APPEAL_APPLICATION_ERROR' ||
      appealApplicationState?.value === 'INITIATE_APPEAL_APPLICATION'
    )
      setShowModal({
        show: false,
        type: '',
      });
    setIsComment(false);
  }, [appealApplicationState]);
  console.log('qqqstate2', appealApplicationState?.value);
  useEffect(() => {
    console.log('lp->', applicationNo, '->', credentialNo);
    statusTimeLinePageSend('START', {
      payload: {},
    });
    if (typeof credentialNo === 'string' && location?.state?.type === 'WP') {
      getWPApplicationPageSend('START', {
        payload: {},
      });
    } else if (
      credentialNo &&
      typeof credentialNo === 'string' &&
      location?.state?.type !== 'WP'
    ) {
      getCertificatePageSend('START', {
        payload: {},
      });
    } else {
      getApplicationPageSend('START', {
        payload: {},
      });
    }
  }, []);
  if (
    initialData?._initialData?.evidencedocuments &&
    initialData?._initialData?.evidencedocuments?.length > 0 &&
    isAppealed === false
  ) {
    setAppeal(true);
  }
  if (
    (initialData?.status === 'APPLICATION_DENIED' ||
      initialData?.status === 'MISSING_INFORMATION' ||
      initialData?.status === 'DOCUMENTATION_REJECTED') &&
    !isComment &&
    initialData &&
    initialData?.status
  ) {
    setIsComment(true);
  }
  const SwalWithBootstrapButtons = withReactContent(
    Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary me-3',
        cancelButton: 'btn btn-secondary',
      },
      buttonsStyling: false,
    })
  );

  const isExpired = (validTill: string) => {
    var date1 = moment(validTill);
    var date2 = moment();
    var days = date1.diff(date2, 'days');
    console.log(`isExpired :`, days);
    if (days > 0) {
      return false;
    } else return true;
  };
  const closecomment = () => {
    setShowComment(false);
  };
  const getWhoamI = async () => {
    const { whoami } = await appSrv.whoAmI();
    setWhoAmI(whoami);
  };

  useEffect(() => {
    getWhoamI();
  }, []);

  const _onTerminateFormSubmit = (data: any) => {
    log.log('onTerminateFormSubmit ::', data);
    log.log('2232', humanizeString(data?.reasonForTermination));

    terminateWPPageSend('MUTATE', {
      payload: {
        credentialNo: credentialNo,
        comment: data?.reason,
        reason: humanizeString(data?.reasonForTermination),
      },
    });

    setShowModal({
      type: '',
      show: false,
    });
  };

  const onRefresh = () => {
    if (typeof credentialNo === 'string' && location?.state?.type === 'WP') {
      getWPApplicationPageSend('TRIGGER_REFRESH', {});
    } else if (
      credentialNo &&
      typeof credentialNo === 'string' &&
      location?.state?.type !== 'WP'
    ) {
      getCertificatePageSend('TRIGGER_REFRESH', {});
    } else {
      getApplicationPageSend('TRIGGER_REFRESH', {});
    }
    appealApplicationSend('TRIGGER_REFRESH', {});
    rejectedDocumentsApplicationSend('TRIGGER_REFRESH', {});
    RejectedDocsApplicantSend('TRIGGER_REFRESH', {});
  };
  const onAppealBtnSubmit = (data) => {
    appealApplicationSend('MUTATE', {
      payload: {
        ...data,
        applicationNo: applicationNo,
      },
    });
    console.log('pppppaaaaa', data);
  };

  const onDownload = () => {
    if (!initialData?.pdf && initialData?.applicationNo) {
      logger.log('download clicked', initialData);
      getPdfPageSend('START', {
        payload: initialData?.applicationNo,
      });
    }

    if (!initialData?.pdf) {
      toast.success('your application download will commence shortly', {
        duration: 3000,
      });
    }
    console.log('lfg->', initialData?.pdf);
    try {
      // const _pdfFile = await getSrv()?.agent?.getPdfDetail(credentialNo || credentialNo || applicationNo)
      if (initialData?.pdf) {
        let byteCharacters = atob(initialData?.pdf);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let _fileName = credentialNo ?? applicationNo;
        let fileName = `${_fileName}.pdf`;
        let file = new Blob([byteArray], { type: 'application/pdf' });
        let link = document.createElement('a');
        link.href = URL.createObjectURL(file);
        link.download = fileName;
        link.click();

        // console.log('file->', fileURL);
        // window.open(fileURL, '_blank');
      }
    } catch (err: any) {
      console.log('Pdf Not Available', err);
      toast.error(err || 'Failed to download Application, Please try again.');
    }
  };

  const onRejectedDocBtnSubmit = (data) => {
    setShowModal({
      show: false,
      type: '',
    });
    console.log('rejectedclicked-->', data);
    (initialData?.type === 'NEW_WORK_PERMIT' ||
      initialData?.type === 'RENEW_WORK_PERMIT' ||
      initialData?.type === 'CARICOM_NEW_WORK_PERMIT' ||
      initialData?.type === 'CARICOM_RENEW_WORK_PERMIT') &&
      rejectedDocumentsApplicationSend('MUTATE', {
        payload: {
          ...data,
          applicationNo: applicationNo,
        },
      });
    (initialData?.type === 'MARRIAGE_EXEMPTION' ||
      initialData?.type === 'CSME_VERIFICATION' ||
      initialData?.type === 'NEW_CSME_CERTIFICATE' ||
      initialData?.type === 'RENEW_CSME_CERTIFICATE') &&
      RejectedDocsApplicantSend('MUTATE', {
        payload: {
          ...data,
          applicationNo: applicationNo,
        },
      });
    console.log('onRejectedDocBtnSubmit', data);
  };

  const onMissingInfoBtnSubmit = (data) => {
    // toast.success("MissingInfoSubmitClicked")
    console.log('missingInfoSubmitdata', data);
  };
  console.log('typeeeeeee->', data?.applicationNo);
  console.log(initialData, 'lp->alkdsgsafdkl');
  const setApplications = () => {
    const { applicationNo, credentialNo } = useApplication();
    if (initialData?.status === 'CREDENTIAL_DOES_NOT_EXIST') {
      if (moment(initialData?.validTill).isBefore(moment()))
        initialData.status = 'EXPIRED';

      const expiringIn = moment(initialData?.validTill).diff(
        moment(),
        'months'
      );
      if (expiringIn <= 3) initialData.status = 'EXPIRING_SOON';
      else initialData.status = 'ACTIVE';
    }

    if (
      (initialData?.status === 'EXPIRING_SOON' ||
        initialData?.status === 'EXPIRED') &&
      initialData?.renewalStatus === 'PENDING_FOR_RENEWAL'
    ) {
      if (data?.type === 'MARRIAGE_EXEMPTION_CERTIFICATE') {
        renewMarriageExemptionPageSend('MUTATE', {
          payload: {
            credentialNo: credentialNo,
          },
        });
      } else if (data?.type === 'CSME_CERTIFICATE') {
        renewCSMECertPageSend('MUTATE', {
          payload: {
            credentialNo: credentialNo,
          },
        });
      } else if (typeof credentialNo === 'string') {
        renewWorkPermitPageSend('MUTATE', {
          payload: {
            credentialNo: credentialNo,
          },
        });
      }
    } else if (initialData?.status === 'APPLICATION_DENIED') {
      setShowModal({
        type: 'appeal',
        show: true,
      });

      console.log('appeal clicked');
    } else if (initialData?.status === 'MISSING_INFORMATION') {
      // toast.success("missing info clicked eyy");

      history(`/application-form?id=${applicationNo}`);
      // setShowModal({
      //   show: true,
      //   type: 'missingInfo',
      // });
    } else if (initialData?.status === 'DOCUMENTATION_REJECTED') {
      // toast.success("update doc clicked")
      setShowModal({
        type: 'docRejected',
        show: true,
      });
    } else {
      storageService.set(
        'payableApplications',
        [{ id: applicationNo, status: initialData?.status }],
        'session'
      );
      props?.onPaymentClick && props?.onPaymentClick();
    }
  };

  const _terminateApplication = () => {
    const { applicationNo } = useApplication();
    console.log('showmodal->', showModal);
    !showModal.show &&
      setShowModal({
        type: 'terminate',
        show: true,
      });
  };
  console.log('comments->', showcomment);
  const _onPayClick = async (data: any) => {
    //@ts-ignore
    const result = await SwalWithBootstrapButtons.fire({
      icon: 'warning',
      title: 'Renew Work Permit',
      text: 'The renew application will go to draft applications',
      allowOutsideClick: false,
      confirmButtonText: 'Ok',
    });
    console.log('ASFKASDGFSADF', result);
    if (result.isConfirmed) {
      // console.log("ASFKASDGFSADF",result);
      props?.onRenewClick && props?.onRenewClick(data);
    } else {
      onRefresh();
    }
  };
  useEffect(() => {
    const data = renewWorkPermitPageState?.event?.data?.value?.applicationNo;
    if (renewWorkPermitPageState?.matches('CREATE_APPLICATION_SUCCESS')) {
      _onPayClick(data);
      // props?.onRenewClick && props?.onRenewClick(data);
    }
  }, [
    renewWorkPermitPageState?.matches('CREATE_APPLICATION_SUCCESS') &&
      renewWorkPermitPageState?.event?.data?.value,
  ]);

  useEffect(() => {
    const data =
      renewMarriageExemptionPageState?.event?.data?.value?.applicationNo;
    if (
      renewMarriageExemptionPageState?.matches('CREATE_APPLICATION_SUCCESS')
    ) {
      console.log('hahadata is=>', renewMarriageExemptionPageState, data);

      props?.onRenewClick && props?.onRenewClick(data);
    }
  }, [
    renewMarriageExemptionPageState?.matches('CREATE_APPLICATION_SUCCESS') &&
      renewMarriageExemptionPageState?.event?.data?.value,
  ]);

  useEffect(() => {
    const data = renewCSMECertPageState?.event?.data?.value?.applicationNo;
    if (data && renewCSMECertPageState?.matches('CREATE_APPLICATION_SUCCESS')) {
      props?.onRenewClick && props?.onRenewClick(data);
    }
  }, [
    renewCSMECertPageState?.matches('CREATE_APPLICATION_SUCCESS') &&
      renewCSMECertPageState?.event?.data?.value,
  ]);
  // useEffect(()=>{
  //   console.log(RejectedDocsApplicantState.value,"state-->000")
  //   console.log(rejectedDocumentsApplicationState.value,"state-->001")
  //   console.log(getApplicationPageState.value,"state-->002")
  //   // console.log(RejectedDocsApplicantState.value,"state-->000")
  // })
  const _renderPage = () => {
    if (getApplicationPageState?.matches('GET_APPLICATION')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.getApplication || {})} />
      );
    }
    if (getWPApplicationPageState?.matches('GET_APPLICATION')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.getWorkPermit || {})} />
      );
    }
    if (getCertificatePageState?.matches('GET_APPLICATION')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.getCertificate || {})} />
      );
    }
    if (
      renewWorkPermitPageState?.matches('INITIATE_CREATE_APPLICATION') ||
      renewCSMECertPageState?.matches('INITIATE_CREATE_APPLICATION') ||
      renewMarriageExemptionPageState?.matches('INITIATE_CREATE_APPLICATION')
    ) {
      return (
        <Loader
          {...(staticPageContentConfig?.loading?.renewApplication || {})}
        />
      );
    }

    if (appealApplicationState?.value === 'INITIATE_APPEAL_APPLICATION') {
      return (
        <Loader
          {...(staticPageContentConfig?.loading?.appealApplication || {})}
        />
      );
    }
    if (appealApplicationState?.value === 'APPEAL_APPLICATION_SUCCESS') {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.appealSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }

    if (
      rejectedDocumentsApplicationState?.value === 'INITIATE_REJECTED_DOCUMENTS'
    ) {
      return (
        <Loader
          {...(staticPageContentConfig?.loading?.appealApplication || {})}
        />
      );
    }
    if (
      rejectedDocumentsApplicationState?.value === 'REJECTED_DOCUMENTS_SUCCESS'
    ) {
      console.log('status--->', rejectedDocumentsApplicationState?.value);
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.appealSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (
      RejectedDocsApplicantState?.value === 'INITIATE_REJECTED_DOCS_APPLICANT'
    ) {
      return (
        <Loader
          {...(staticPageContentConfig?.loading?.appealApplication || {})}
        />
      );
    }
    if (
      RejectedDocsApplicantState?.value === 'REJECTED_DOCS_APPLICANT_SUCCESS'
    ) {
      console.log('status--->', RejectedDocsApplicantState?.value);
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.appealSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }

    if (terminateWPPageState?.matches('INITIATE_TERMINATE_WP')) {
      return (
        <Loader
          {...(staticPageContentConfig?.loading?.terminatingWorkPermit || {})}
        />
      );
    } else if (
      terminateWPPageState?.matches('TERMINATE_WP_SUCCESS') &&
      terminateWPPageState?.event?.data?.value
    ) {
      props?.onTerminateSuccess && props?.onTerminateSuccess();
    }

    if (
      getApplicationPageState?.matches('RENDER_APPLICATION') ||
      getWPApplicationPageState?.matches('RENDER_APPLICATION') ||
      (getCertificatePageState?.matches('RENDER_APPLICATION') &&
        Object.entries(initialData)?.length > 0)
    ) {
      console.log('initia->', initialData?.status, '3', data?.type);
      return (
        // console.log('getwidgetdata->', getMarriageWidgetData(marriageExemptionFormData?.fields,{...initialData?.applicantInfo||{},...initialData?.jamaicanInfo || {},...initialData?.marriageInfo || {}})),
        <>
          {/* @ts-ignore */}
          {(applicationNo &&
            (data?.type === 'MARRIAGE_EXEMPTION' ||
              data?.type === 'RENEW_MARRIAGE_EXEMPTION')) ||
          (credentialNo &&
            typeof credentialNo === 'string' &&
            data?.type === 'MARRIAGE_EXEMPTION') ? (
            <ItemSpecVenusWidget
              {...getMarriageWidgetData({
                fields: marriageExemptionFormData?.fields,
                initialData: {
                  ...initialData?._marriageInitialData,
                  status: initialData?.status || '',
                },
                marriageExemptionFormData,
                timelinedata,
                data,
                applicationNo,
                credentialNo,
                from: location?.state?.from,
                whoAmI,
              })}
              onDownload={onDownload}
              onVerify={() => {
                initialData?.status === 'CREDENTIAL_DOES_NOT_EXIST'
                  ? toast.error('User not created a wallet')
                  : initialData?.verifyURL
                  ? window.open(initialData?.verifyURL, '_blank')
                  : toast.success('Coming soon...');
              }}
              // {...getWidgetData()}
              onListClick={(item: any) => console.log(`item clicked`, item)}
              onPageChange={(event: any) => console.log(`page change`, event)}
              status={APPLICATION_STATUS[initialData?.status]}
              onSubmit={setApplications}
              onTerminate={_terminateApplication}
              onActionClick={(key, listId) =>
                console.log(`on action click`, key, listId)
              }
              iscomment={isComment}
              showcomment={showcomment}
              status={APPLICATION_STATUS[initialData?.status]}
              closecomment={closecomment}
              setShowComment={setShowComment}
              // onItemClick={(itemId: string) => window.alert(itemId)}
            />
          ) : (
            <ItemSpecVenusWidget
              // {...getMarriageWidgetData(marriageExemptionFormData?.fields,{...initialData?._marriageInitialData})}
              {...getWidgetData({
                data,
                initialData,
                applicationNo,
                credentialNo,
                workPermitFormData,
                csmeFormData,
                renewCsmeFormData,
                timelinedata,
                marriageExemptionFormData,
                csmeVerificationFormData,
                renewWorkPermitFormData,
                roeworkPermitFormData,
                from: location?.state?.from,
                whoAmI,
                orgrole: oragrole,
              })}
              onDownload={onDownload}
              onVerify={() => {
                initialData?.status === 'CREDENTIAL_DOES_NOT_EXIST'
                  ? toast.error('Wallet was not installed')
                  : initialData?.verifyURL
                  ? window.open(initialData?.verifyURL, '_blank')
                  : toast.success('Coming soon...');
              }}
              onListClick={(item: any) => console.log(`item clicked`, item)}
              onPageChange={(event: any) => console.log(`page change`, event)}
              onSubmit={setApplications}
              onTerminate={_terminateApplication}
              onActionClick={(key, listId) =>
                console.log(`on action click`, key, listId)
              }
              iscomment={isComment}
              showcomment={showcomment}
              status={APPLICATION_STATUS[initialData?.status]}
              closecomment={closecomment}
              setShowComment={setShowComment}

              // onItemClick={(itemId: string) => window.alert(itemId)}
            />
          )}
        </>
      );
    }

    return <></>;
  };
  const renderTimeLine = () => {
    if (statusTimeLinePageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.loadingProfile || {})}
        />
      );
    }
    if (statusTimeLinePageState?.matches('RENDER_PAGE')) {
      console.log('STATE DATA :', location);
      console.log(
        'timelinedata->',
        statusTimeLinePageState?.event?.data?.value?.data.slice().reverse()
      );
      return (
        <>
          {/* @ts-ignore */}

          <TimelineMercury
            items={statusTimeLinePageState?.event?.data?.value?.data}
            onItemClick={(itemId: string) => {}}
          />
        </>
      );
    }
  };
  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      // let modifiedHeading =staticPageContentConfig?.header;
      // console.log("getwidgetdata--->",staticPageContentConfig?.applicationcategory);
      let modifiedHeading = {
        ...staticPageContentConfig?.header,
        headerDescription:
          staticPageContentConfig?.applicationcategory[initialData?.status],
      };
      return (
        <>
          <Header
            {...(location?.state?.from === 'renew' ||
            location?.state?.from === 'credential'
              ? typeof credentialNo === 'string' &&
                location?.state?.type === 'WP'
                ? staticPageContentConfig?.wpHeader
                : staticPageContentConfig?.certificateHeader
              : modifiedHeading || {})}
            onRefreshClick={onRefresh}
            goBack={props?.goBack}
          />
        </>
      );
    }
    return null;
  };

  const _renderErrorModals = () => {
    if (
      getApplicationPageState?.matches('RENDER_APPLICATION_ERROR') ||
      getWPApplicationPageState?.matches('RENDER_APPLICATION_ERROR') ||
      appealApplicationState?.matches('APPEAL_APPLICATION_ERROR') ||
      rejectedDocumentsApplicationState?.matches('REJECTED_DOCUMENTS_ERROR') ||
      RejectedDocsApplicantState?.matches('REJECTED_DOCS_APPLICANT_ERROR')
    ) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getUsers || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };
  console.log('sdkhfvsjdf', data);
  const onHideClick = () => {
    if (showModal?.show) {
      setShowModal({
        type: '',
        show: false,
      });
    }
  };

  const _renderModal = () => {
    if (showModal?.show) {
      if (showModal?.type === 'terminate') {
        return (
          <TerminateFormModal
            FIELDS={staticPageContentConfig?.terminateWp?.FIELDS}
            layout={staticPageContentConfig?.terminateWp?.layout}
            onHideClick={onHideClick}
            onTerminateFormSubmit={_onTerminateFormSubmit}
          />
        );
      } else if (showModal?.type === 'appeal') {
        return (
          <AppealForm
            ModalTitle={'Appeal'}
            type={
              data?.type === 'MARRIAGE_EXEMPTION' ||
              data?.type === 'RENEW_MARRIAGE_EXEMPTION'
                ? 'MARRIAGE_EXEMPTION'
                : data?.type === 'NEW_CSME_CERTIFICATE' ||
                  data?.type === 'RENEW_CSME_CERTIFICATE'
                ? 'CSME'
                : data?.type === 'CARICOM_NEW_WORK_PERMIT' ||
                  data?.type === 'CARICOM_RENEW_WORK_PERMIT'
                ? 'CARICOM_WP'
                : 'WORK_PERMIT'
            }
            formConfig={staticPageContentConfig?.appealFormData}
            showModal={showModal?.show}
            onHideClick={onHideClick}
            onSubmit={onAppealBtnSubmit}
          />
        );
      } else if (showModal?.type === 'missingInfo') {
        <MissingInfoForm
          formConfig={staticPageContentConfig?.missingInfoFormData}
          showModal={showModal?.show}
          onHideClick={onHideClick}
          onSubmit={onMissingInfoBtnSubmit}
        />;
      } else if (showModal?.type === 'docRejected') {
        return (
          <DocRejectedForm
            ModalTitle={'Update Documents'}
            type={
              data?.type === 'MARRIAGE_EXEMPTION' ||
              data?.type === 'RENEW_MARRIAGE_EXEMPTION'
                ? 'MARRIAGE_EXEMPTION'
                : data?.type === 'NEW_CSME_CERTIFICATE' ||
                  data?.type === 'RENEW_CSME_CERTIFICATE'
                ? 'CSME'
                : data?.type === 'CARICOM_NEW_WORK_PERMIT' ||
                  data?.type === 'CARICOM_RENEW_WORK_PERMIT'
                ? 'CARICOM_WP'
                : 'WORK_PERMIT'
            }
            formConfig={staticPageContentConfig?.docRejectedFormData}
            showModal={showModal?.show}
            onHideClick={onHideClick}
            onSubmit={onRejectedDocBtnSubmit}
          />
        );
      }
    }

    return (
      <Comments
        comment={data?.comment}
        show={showcomment}
        handleClose={closecomment}
      />
    );
  };

  return (
    <div>
      {_renderHeader()}
      {_renderPage()}
      {_renderErrorModals()}
      {_renderModal()}
      {/* {renderTimeLine()} */}
    </div>
  );
};
